module.exports = __webpack_public_path__ + "static/staticSectionImage2-471aff19bd9f6eaf2705e2878731cfee.png";